import { useCallback } from 'react';

// Chakra
import {
  Table,
  Tbody,
  Tr,
  Td,
  useColorModeValue,
  Thead,
} from '@chakra-ui/react';

import Card from 'components/Card/Card';

export default function GiveawayPrizes({ giveaway }) {
  const textColor = useColorModeValue('gray.700', 'white');

  const getOrdinalSuffix = useCallback((number) => {
    const lastDigit = number % 10;
    const lastTwoDigits = number % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
      return `${number}th`;
    }

    switch (lastDigit) {
      case 1:
        return `${number}st`;
      case 2:
        return `${number}nd`;
      case 3:
        return `${number}rd`;
      default:
        return `${number}th`;
    }
  }, []);

  return (
    <Card padding="24px" mb="40px">
      <Table color={textColor}>
        <Thead>
          <Tr>
            <Td>Place</Td>
            <Td>Title</Td>
          </Tr>
        </Thead>
        <Tbody>
          {giveaway.prizes.map((prize) => (
            <Tr key={prize.index}>
              <Td>{getOrdinalSuffix(prize.index + 1)}</Td>
              <Td>{prize.title}</Td>
            </Tr>
          ))}
          <Tr></Tr>
        </Tbody>
      </Table>
    </Card>
  );
}
